<template>
    <div>
        <div v-if="mode === 'edit'">
            <span style="font-weight: bold;">系统上传要求：</span>单图分辨率800*800px，最大不得超过2M｜仅支持JPG、JPEG格式
        </div>

        <div>
            <div
                v-if="mode ==='edit' || value.length"
                style="display: flex;align-items: center;"
            >
                <!-- 权限：芥末-基础库-详情页-修改运营信息 -->
                <DragFileUpload
                    v-for="(rulesItem, rulesIndex) in getPicRule.picRule"
                    ref="dragfileupload"
                    :key="rulesIndex"
                    :disabled="isDisabled"
                    :value="getImageValue(rulesIndex)"
                    :show-only="isShowOnly"
                    :desc="rulesItem"
                    style="width:150px"
                    v-bind="uploadProps"
                    :validate-rule="validateRule"
                    @input="(arr)=>skuPictureListInput(arr,rulesIndex)"
                />
            </div>
            <span v-else>无</span>
        </div>

        <div class="example-list">
            <mc-link
                style="color: #999"
                @click="isShowExample = !isShowExample"
            >
                {{ isShowExample ? '关闭示例' : '查看示例' }}
            </mc-link>

            <mc-link path="https://p0.meituan.net/mallimages/1290b076c36b9b0cfc13be365272fce9976419.jpg">
                查看审核要求
            </mc-link>
        </div>

        <transition name="example-image">
            <div v-if="isShowExample">
                <div
                    v-for="(urlItem, urlIndex) in getPicRule.exampleImgUrlList"
                    :key="urlIndex"
                    class="image-list"
                >
                    <mc-image
                        class="pic-image"
                        :src="urlItem"
                        :preview-url-list="getPicRule.exampleImgUrlList"
                        :preview-first-index="urlIndex"
                    />

                    <div style="text-align: center; color: #999; margin-top: -10px">
                        {{ getPicRule.picRule && getPicRule.picRule[urlIndex] }}
                    </div>
                </div>
            </div>
        </transition>
    </div>
</template>

<script>
/* eslint-disable import/no-unresolved */
import { computed, getCurrentInstance, ref } from '@vue/composition-api';
import DragFileUpload from 'components/DragFileUpload';
import judgeAttrUnderReview from 'utils/spAttrsApprove';
import MixinJudgeRejectedAttrsDisabled from './createNewProduct/mixins/rejectedDisabled';

export default {
    components: {
        DragFileUpload,
    },
    mixins: [MixinJudgeRejectedAttrsDisabled],
    props: {
        value: {
            type: Array,
            default: () => ([]),
        },
        // 状态
        mode: {
            type: String,
            default: '',
        },
        // 审核字段
        modifiyAttrs: {
            type: Array,
            default: () => ([]),
        },
        judgeAttrDisabled: {
            type: Boolean,
            default: true,
        },
        // 校验规则
        validateRule: {
            type: Object,
            default: () => ({}),
        },
        // 图片规则
        picRule: {
            type: Object,
            default: () => ({}),
        },
    },
    setup(props) {
        const { proxy } = getCurrentInstance();

        // 配置项
        const uploadProps = Object.freeze({
            style: 'width:150px',
            maxPic: 1,
            rowCount: 1,
            margin: 5,
            isValidate: true,
            dgWaterMark: true,
        });

        const isShowExample = ref(true);

        // 是否禁用
        const isDisabled = computed(() => judgeAttrUnderReview(props.modifiyAttrs, 'skuMainPictureList') || props.judgeAttrDisabled) || proxy.MixinJudgeRejectedAttrsDisabled('skuPictureList');
        const isShowOnly = computed(() => props.mode === 'show' || judgeAttrUnderReview(props.modifiyAttrs, 'skuMainPictureList'));

        // value值
        const getImageValue = computed(() => (rulesIndex) => {
            const url = props.value?.[rulesIndex];
            return url ? [url] : [];
        });

        const skuPictureListInput = (urlList, rulesIndex) => {
            const pictureList = [...props.value];
            pictureList[rulesIndex] = urlList?.[0] || '';
            proxy.$emit('input', pictureList);
        };

        const getPicRule = computed(() => {
            const { exampleImgUrlList, ...items } = props.picRule || {};
            const descriptionsArray = Object.values(items);
            return {
                exampleImgUrlList,
                picRule: descriptionsArray,
            };
        });

        const initImgArray = (index, urlArr) => {
            const pictureList = [...props.value];
            pictureList[index] = urlArr[0];
            proxy.$refs.dragfileupload[index].initImgArray(urlArr);
            if (!urlArr[0])proxy.$refs.dragfileupload[index].removeImage();
        };

        return {
            judgeAttrUnderReview,
            uploadProps,
            isShowExample,
            getPicRule,
            isDisabled,
            isShowOnly,
            getImageValue,
            skuPictureListInput,
            initImgArray,
        };
    },
};
</script>

<style lang="scss" scoped>
.image-list {
    display: inline-block;
    margin-right: 20px;
}

.pic-image {
    width: 130px;
    height: 130px;
    padding: 5px;
    border: 1px solid #e0e0e0;
    border-radius: 3;
}

.example-list {
    display: flex;
    align-items: center;
    padding: 10px 0;
}

.example-image-enter-active, .example-image-leave-active {
    transition: all 0.5s ease;
}

.example-image-enter, .example-image-leave-to /* .slide-leave-active in <2.1.8 */ {
    transform: translateY(-20px);
    opacity: 0;
}

.mc-button {
    &.ml-400 {
        margin-left: 380px;
    }

    &.rotate-90,
    &.rotate--90 {
        display: flex;
        align-items: center;
        justify-content: center;
        transition: transform 0.3s ease;
    }

    &.rotate-90 {
        transform: rotate(90deg);
    }

    &.rotate--90 {
        transform: rotate(-90deg);
    }

    ::v-deep .mtdicon-fast-backward {
        font-size: 25px;
    }
}
.wrapper {
    border: none;
    ::v-deep {
        .img-area,
        .add-img {
            width: 130px !important;
            height: 130px !important;
            margin: 0 !important;
        }
    }
}

</style>
